/* eslint-disable @typescript-eslint/no-explicit-any */
import { lstorage } from '@services/lstorage';
import { Prefixed, TMap } from '../helpers/types';

const utmKeys = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const satisfies readonly string[];

type UTMField = (typeof utmKeys)[number];
type UTMData = Partial<TMap<UTMField, string>>;

const getFromURL = (searchParams: string): UTMData => {
  const params = new URLSearchParams(searchParams);
  return utmKeys.reduce((acc, key) => {
    const value = params.get(key);
    if (value) acc[key] = value;
    return acc;
  }, {} as UTMData);
};

const store = (data: UTMData) => {
  Object.entries(data).forEach(([key, value]) => {
    if (value) lstorage.set(key, value);
  });
};

const restore = <T extends string = ''>(prefix?: T): Prefixed<T, UTMData> =>
  utmKeys.reduce((acc, key) => {
    const value = lstorage.get(key);
    if (value) {
      const finalPrefix = (prefix ?? '') as T;
      const newKey =
        finalPrefix === ''
          ? key
          : (`${finalPrefix}${key}` as keyof Prefixed<T, UTMData>);
      (acc as any)[newKey] = value;
    }
    return acc;
  }, {} as Prefixed<T, UTMData>);

export const utmParams = { getFromURL, store, restore };
